export const usePluralization = (template, data, ignoreEmpty) => {
  if (!template && !data) return
  const pattern = /{\s*(\w+?)\s*}/g // {property}
  let isExistValue = false
  let temp = template?.replace(pattern, (_, key) => {
    if (data[key]) {
      isExistValue = true
    }
    return `<span id="rich-${key}">${data[key] || ''}</span>` || ''
  })
  if (ignoreEmpty) isExistValue = true
  return isExistValue ? temp : null
}

export const usePluralizationText = (template, data) => {
  if (!template && !data) return
  const pattern = /{\s*([\w.\[\]]+?)\s*}/g;
  let temp = template?.replace(pattern, (_, key) => {

    return data[key] || ''
  })
  return temp
}
